import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GQIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GQ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12.288h16.384V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={17}
        height={13}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12.288h16.384V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G fillRule="evenodd" clipRule="evenodd" mask="url(#b)">
        <Path fill="#009D00" d="M0 0v4.096h16.384V0H0Z" />
        <Path fill="#fff" d="M0 4.096v4.096h16.384V4.096H0Z" />
        <Path fill="#F80000" d="M0 8.192v4.096h16.384V8.192H0Z" />
      </G>
      <Path
        fill="#0075D5"
        fillRule="evenodd"
        d="M0 0v12.288l4.096-6.066L0 0Z"
        clipRule="evenodd"
      />
      <Mask
        id="c"
        width={5}
        height={13}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12.288l4.096-6.066L0 0Z"
          clipRule="evenodd"
        />
      </Mask>
      <Path
        fill="#FFD500"
        stroke="#000"
        strokeWidth={0.032}
        d="m7.457 4.768.006-.006.009.001.136.017-.07-.12-.004-.007.004-.007.056-.125-.133.03-.009.002-.005-.006-.103-.093-.011.138-.001.007-.007.005-.122.067.127.054.009.004.001.008.027.135.09-.104ZM7.97 4.768l.005-.006.009.001.136.017-.07-.12-.004-.007.003-.007.057-.125-.133.03-.009.002-.005-.006-.103-.093-.011.138-.001.007-.007.005-.122.067.127.054.009.004.001.008.027.135.09-.104ZM8.481 4.768l.006-.006.009.001.136.017-.07-.12-.004-.007.004-.007.056-.125-.133.03-.009.002-.005-.006-.103-.093-.011.138-.001.007-.007.005-.122.067.127.054.009.004.001.008.027.135.09-.104ZM8.993 4.768 9 4.762l.009.001.136.017-.07-.12-.004-.007.004-.007.056-.125-.133.03-.009.002-.005-.006-.103-.093-.011.138-.001.007-.007.005-.122.067.127.054.009.004.001.008.027.135.09-.104ZM9.505 4.768l.006-.006.009.001.136.017-.07-.12-.004-.007.003-.007.057-.125-.133.03-.009.002-.005-.006-.103-.093-.011.138-.001.007-.007.005-.122.067.127.054.009.004.001.008.027.135.09-.104ZM10.017 4.768l.006-.006.009.001.136.017-.07-.12-.004-.007.004-.007.056-.125-.133.03-.009.002-.005-.006-.103-.093-.011.138-.001.007-.007.005-.122.067.127.054.009.004.001.008.027.135.09-.104Z"
      />
      <Path
        stroke="#373737"
        strokeWidth={0.064}
        d="M9.696 5.152v1.504a.992.992 0 1 1-1.984 0V5.152h1.984Z"
      />
      <Path
        fill="#6F3E1D"
        fillRule="evenodd"
        d="M8.564 6.123s-.103 1.212-.206 1.285c-.104.073.494.11.55.055.058-.055-.26-1.042-.15-1.34.109-.297.285-.321.285-.321s-.222-.047-.286.042c-.063.09-.252-.042-.252-.042l.059.321Z"
        clipRule="evenodd"
      />
      <Path
        fill="#009D29"
        fillRule="evenodd"
        d="M8.541 6.055h-.08s-.053.21-.176.105c-.124-.105-.298-.068-.298-.068s.016-.126.205-.176c.19-.05.27-.456.27-.456s.268-.1.431.105c.163.204.393.117.393.117s.168.095.084.234-.227.24-.352.139c-.125-.101-.477 0-.477 0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
